import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { RxFormContext } from '../Context';
import { createDebug } from '../utils/debug';

const debug = createDebug('useFieldValue');

export function useFieldValue(field: string): any {
    const { getValueStream } = useContext(RxFormContext);

    const [state, setState] = useState(undefined);
    useEffect(() => {
        debug('++mount', field);
        const sub = getValueStream()
            .pipe(
                map((s) => s?.[field]),
                distinctUntilChanged(),
                tap(setState),
            )
            .subscribe();
        return () => sub.unsubscribe();
    }, [field, getValueStream]);
    return state;
}
